import { useEffect, useState } from "react";
import maaFace from "./puja-maa.webp";
import "./PujaCountdown.css";

// Calendar-day countdown to Maha Sashti in Kolkata, not the selected report date.
const DAY_MS = 86400000;
const KOLKATA_OFFSET_MS = 19800000;
const SASHTI_DAY = Date.UTC(2026, 9, 17);

export function daysUntilSashti(now = new Date()) {
  const kolkata = new Date(now.getTime() + KOLKATA_OFFSET_MS);
  const today = Date.UTC(kolkata.getUTCFullYear(), kolkata.getUTCMonth(), kolkata.getUTCDate());
  return Math.round((SASHTI_DAY - today) / DAY_MS);
}

function Lotus() {
  return (
    <svg viewBox="0 0 72 42" fill="none" aria-hidden="true" focusable="false">
      <g stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M36 29C23 20 29 9 36 3c7 6 13 17 0 26Z" fill="currentColor" fillOpacity=".15" />
        <path d="M36 29C21 29 18 19 18 13c10 1 16 7 18 16Zm0 0c15 0 18-10 18-16-10 1-16 7-18 16Z" />
        <path d="M36 30C18 34 12 25 11 20c9 0 16 4 25 10Zm0 0c18 4 24-5 25-10-9 0-16 4-25 10Z" />
        <path d="M36 32v6m-13-3c-6 5-13 1-13-3 0-4 6-4 6 0m33 3c6 5 13 1 13-3 0-4-6-4-6 0M3 37h6m54 0h6" />
      </g>
      <circle cx="36" cy="39" r="1.7" fill="currentColor" />
    </svg>
  );
}

export default function PujaCountdown() {
  const [days, setDays] = useState(() => daysUntilSashti());

  useEffect(() => {
    let timer;
    const update = () => {
      window.clearTimeout(timer);
      const now = new Date();
      setDays(daysUntilSashti(now));
      const sinceMidnight = ((now.getTime() + KOLKATA_OFFSET_MS) % DAY_MS + DAY_MS) % DAY_MS;
      timer = window.setTimeout(update, DAY_MS - sinceMidnight + 100);
    };
    const onVisible = () => { if (!document.hidden) update(); };
    update();
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", update);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", update);
    };
  }, []);

  // This seasonal decoration ends after Sashti, without counting below zero.
  if (days < 0) return null;

  return (
    <section className="puja-countdown" aria-label="Durga Puja countdown" data-testid="puja-countdown">
      <span className="puja-countdown__ornament"><Lotus /><i /></span>
      <div className="puja-countdown__content">
        <img className="puja-countdown__face" src={maaFace} alt="Maa Durga" width="64" height="64" />
        <span className="puja-countdown__greeting" lang="bn">{days === 0 ? "শুভ ষষ্ঠী" : "মা আসছে"}</span>
        <span className="puja-countdown__divider" aria-hidden="true">✦</span>
        <div className="puja-countdown__copy" aria-live="polite" aria-atomic="true">
          <strong>{days === 0 ? "Happy Sashti" : `${days} ${days === 1 ? "day" : "days"} left`}</strong>
          <span>{days === 0 ? "Durga Puja 2026" : "Till Sashti"}</span>
        </div>
      </div>
      <span className="puja-countdown__ornament puja-countdown__ornament--right"><Lotus /><i /></span>
    </section>
  );
}
